import { render, staticRenderFns } from "./NonColourManagedWorkflow.vue?vue&type=template&id=2d2902e1&scoped=true&"
import script from "./NonColourManagedWorkflow.vue?vue&type=script&lang=js&"
export * from "./NonColourManagedWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./NonColourManagedWorkflow.vue?vue&type=style&index=0&id=2d2902e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2902e1",
  null
  
)

export default component.exports